import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M28 10h-6v1.5h6a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-3v2.324L20.894 23.5H16a1.5 1.5 0 0 1-1.5-1.5v-1.5H13V22a2.96 2.96 0 0 0 2.958 2.958L20.5 25l5.1 2.889a.55.55 0 0 0 .333.111.56.56 0 0 0 .567-.562V25H28a3 3 0 0 0 3-2.958v-9.084A2.994 2.994 0 0 0 28 10m-7.5 6V6.958A3 3 0 0 0 17.5 4H4a3 3 0 0 0-3 2.958v9A3.014 3.014 0 0 0 4 19h1.5v2.437a.56.56 0 0 0 .563.563.57.57 0 0 0 .334-.111L11.5 19h6a3 3 0 0 0 3-3m-9.394 1.5L7 19.825V17.5H4A1.5 1.5 0 0 1 2.5 16V7A1.5 1.5 0 0 1 4 5.5h13.5A1.5 1.5 0 0 1 19 7v9a1.5 1.5 0 0 1-1.5 1.5Z"
    }, null, -1)
  ])))
}
export default { render: render }